import { createFileRoute, notFound } from "@tanstack/react-router";
import { HijriMonthPage } from "@/components/pages/HijriMonthPage";
import { HIJRI_MONTHS } from "@/lib/calendar/hijri";

export const Route = createFileRoute("/kalender-hijriah/$hyear/$hmonth/")({
  beforeLoad: ({ params }) => {
    if (params.hyear.startsWith("$") || params.hmonth.startsWith("$")) {
      throw notFound();
    }
  },
  loader: ({ params }) => {
    const hYear = parseInt(params.hyear, 10);
    const hMonth = parseInt(params.hmonth, 10);
    if (!Number.isFinite(hYear) || hYear < 1300 || hYear > 1600) throw notFound();
    if (!Number.isFinite(hMonth) || hMonth < 1 || hMonth > 12) throw notFound();
    return { hYear, hMonth };
  },
  head: ({ loaderData }) => {
    if (!loaderData) return {};
    const { hYear, hMonth } = loaderData;
    const monthName = HIJRI_MONTHS[hMonth - 1];
    const title = `Kalender ${monthName} ${hYear} H - Tanggal Hijriah & Masehi`;
    const desc = `Kalender Islam (Hijriah) ${monthName} ${hYear} H lengkap dengan konversi Masehi, hari penting Islam, dan libur nasional Indonesia.`;
    const idUrl = `https://hari.co.id/kalender-hijriah/${hYear}/${hMonth}/`;
    return {
      meta: [
        { title },
        { name: "description", content: desc },
        { property: "og:title", content: title },
        { property: "og:description", content: desc },
        { property: "og:url", content: idUrl },
        { property: "og:locale", content: "id_ID" },
        { property: "og:locale:alternate", content: "en_US" },
      ],
      links: [{ rel: "canonical", href: idUrl }],
    };
  },
  component: () => {
    const { hYear, hMonth } = Route.useLoaderData();
    return <HijriMonthPage hYear={hYear} hMonth={hMonth} />;
  },
  notFoundComponent: () => <div className="p-8 text-center">Bulan Hijriah tidak valid.</div>,
  errorComponent: ({ error }) => <div className="p-8 text-center">Error: {error.message}</div>,
});